import { IUpdateObraInformacoesUseCase } from "../../../presentation/useCases/update/update_obra_informacoes_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateInformacaoObraUseCase
 */

export class UpdateObraInformacoesUseCase implements IUpdateObraInformacoesUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateObraInformacoes(
    idObraInformacoes: number,
    idFuncionario: number,
    data: Date,
    descInformacoes: string,
  ): Promise<void> {
    await this.repository.updateObraInformacoes(
      idObraInformacoes,
      idFuncionario,
      data,
      descInformacoes,
    );
  }
}
